import React from "react";
import "./News.css";
function News() {
  return (
    <div className="news">
      <div className="title">• Ukraine braces for 'all-out attack'</div>
      <div className="desc">Top news • 987,862 readers</div>
    </div>
  );
}

export default News;
